import React from 'react'
import Header from "../components/global/Header"
import Footer from "../components/global/Footer"
import StoreData from "../components/stores/StoreData"
import { CaretDownFilled, SearchOutlined } from '@ant-design/icons'
export default function Search() {
  return (
    <div>
      <Header />
      <div className="search">
        <div className="search__header">
          <p className="search__header__title">Search Healthify</p>
          <p className="search__header__subtitle">Over 10, 000 drugs from certified Pharmacy stores</p>

        </div>
        <div className="search-box">
          <form className="search-boxx" action="/search">
            <SearchOutlined style={{ color: '#939CA7', fontSize: '24px' }} />
            <input type="text" name="" id="" placeholder="Search" />
            <button>Stores</button>
            <CaretDownFilled />
          </form>

        </div>

        <div className="search__results">
          <p className="search__results__title">12 Results found</p>

          <StoreData />
          <StoreData />
          <StoreData />
        </div>
      </div>
      <Footer />
    </div>
  )
}